import { LOGO } from "@/data/site";

// Locked logo lockup: apple icon + tightly-cropped wordmark IMAGE ("désir events").
// Using a locally-served image guarantees identical rendering on all environments
// (preview + production), independent of any external asset changes.
const WORDMARK_SRC = "/desir-events-wordmark.png";

const SIZES = {
  sm: { icon: "h-7", wordmark: "h-4" },
  md: { icon: "h-10 md:h-11", wordmark: "h-5 md:h-6" },
  lg: { icon: "h-14", wordmark: "h-8" },
};

export default function Logo({ size = "md", className = "" }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <span className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img src={LOGO.iconDark} alt="Désir Events" className={`${s.icon} w-auto`} />
      <img
        src={WORDMARK_SRC}
        alt="désir events — Agence événementielle B2B"
        className={`${s.wordmark} w-auto`}
        data-testid="brand-wordmark"
      />
    </span>
  );
}
